import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getStyleValue } from '../Helpers/Helpers';

import Close from '@mui/icons-material/Close';

import {
	TextField,
	IconButton,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';

class TextArea extends Component {
	constructor(props) {

		super(props);

		this.textInput = React.createRef();

		this.state = {
			dialogOpen: false,
			disabled: false,
			value: props.value || '',
		};
	}
	remove() {
		this.setState({ value: '' }, () => {
			const triggerId = this.props.triggerId;
			if (triggerId) {
				document.getElementById(triggerId).dispatchEvent(new Event(`toggler-close-${triggerId}`));
			}
			if (typeof this.props.onChange === 'function') {
				this.props.onChange('');
			}
			this.handleClose();
		});
	}
	handleOpen() {
		if (this.state.value) {
			this.setState({ dialogOpen: true });
		} else {
			this.remove();
		}
	}
	handleClose() {
		this.setState({ dialogOpen: false });
	}
	handleChange(event) {
		const { value } = event.target;
		this.setState({ value });
	}

	render() {
		// dispatch is filtered out; it will trigger a React warning
		const { name, readOnly, required, floatingLabelText, noClose, saveOnBlur, remarkText, triggerId, dispatch, ...filteredProps } = this.props; // eslint-disable-line no-unused-vars
		const { value, dialogOpen, disabled } = this.state;

		return (
			<div style={{ position: 'relative', marginBottom: getStyleValue('spacing-default')}} {...filteredProps}>
				<div className="textarea-bg">
					<TextField
						variant="standard"
						name={name}
						ref={this.textInput}
						label={floatingLabelText}
						value={value}
						disabled={readOnly || disabled}
						multiline
						rows={2}
						fullWidth
						style={{ marginBottom: 0 }}
						margin="normal"
						InputLabelProps={{ className: 'textarea-label' }}
						inputProps={{ className: 'textarea', 'data-notrequired': this.props['data-notrequired'] }}
						onChange={this.handleChange.bind(this)} />
					<IconButton
						onClick={this.handleOpen.bind(this)}
						hidden={readOnly || noClose}
						style={{ position: 'absolute', right: 5, top: 5 }}
						size="large">
						<Close />
					</IconButton>
				</div>

				<Dialog
					open={dialogOpen}
					onClose={this.handleClose.bind(this)}
					fullWidth
					maxWidth="sm"
					PaperProps={{ className: 'card dialog' }}
				>
					<DialogTitle>{ this.props.t.text_area_delete_note }</DialogTitle>

					<DialogContent>
						<DialogContentText>
							{ this.props.t.text_area_delete_note_check }
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							variant="text"
							color="primary"
							onClick={this.handleClose.bind(this)}
						>
							{ this.props.t.text_area_delete_cancel }
						</Button>
						<Button
							variant="text"
							color="primary"
							onClick={this.remove.bind(this)}
						>
							{ this.props.t.delete }
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

TextArea.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string.isRequired,
};

function mapStateToProps (state) {
	const { t } = state.store;
	return { t };
}

export default connect(mapStateToProps)(TextArea);
